const $productSelect = $('.js-product-main-select');

$('.js-select-variant select').on('change', function() {
  let option_target = '';

  $('.js-select-variant select').each(function() {
    const $this = $(this);
    const $selectedOption = $this.find('option:selected');
    const dataIndex = $selectedOption.data('index');
    const eleValue = $selectedOption.attr('value');

    option_target += `[data-option-${dataIndex}="${eleValue}"]`;
  });

  const selectedVal = $productSelect.find(option_target).val();

  $productSelect.each(function() {
    $productSelect.val(selectedVal)
      .trigger('change');
  });
});
